import React, { useEffect, useState } from 'react'
import EmrVisitsService from '../../../../services/EmrVisitsService'
import Icons from '../../../../components/UI/Icons'
import { capitalizeName } from '../../../../utils/commonUtils'
import Buttons from '../../../../components/UI/Buttons'

const OrdersAndResultsSection = (props) => {
    const [TableData,setTableData]=useState([])
    const{renderResults,visit_id,ToggleOrders,setActiveEditId,addVaccineToogleHandler}=props
  useEffect(()=>{
    fetchOrder()
  },[renderResults])
  const fetchOrder=async()=>{
    try{
        // props.Loader(true)
        const res=await EmrVisitsService.ListOrders(visit_id)
        console.log("oreder",res);
        
        if (res) {
            let passedCnt = 0;
            let totalCnt = 0;
            const tableData = res.map((item, itemIndex) => {
                totalCnt = itemIndex + 1;
                let status = item.status;
                console.log("status1", status);
                if (item.status == 'Completed/Administrated') {
                    item.status = 'passed';
                    status = 'passed'
                }
                if (item.status == 'Ordered') {
                    item.status = 'pending'
                    status = 'pending'
                }
                let statusClr = 'notStarted';
                if (status.toLowerCase() === 'passed' || status === 'The subject Passed the fit test') {
                    statusClr = 'passed';
                    passedCnt++;
                } else if (status === 'Not Started' || status == 'NOT STARTED' || status.toLowerCase()=='not started') {
                    statusClr = 'notStarted'
                } else if (status.toLowerCase() === 'pending') {
                    statusClr = 'pending';
                    if (item?.activity?.activity_type.toLowerCase() == 'lab') {
                        statusClr = 'pendingLab'
                    }
                } else if (status.toLowerCase() === 'pending mro') {
                    statusClr = 'pendingMRO'
                } else if (status.toLowerCase() === 'pending lab') {
                    statusClr = 'pendingLab'
                } else if (status.toLowerCase() === 'failed' || status === 'The subject Failed the fit test') {
                    statusClr = 'failed';
                } else {
                    statusClr = 'pending';
                }
                console.log("status",statusClr);
                
                return {
                    rowId:item?.lab_order?.lab_order_result_id,
                    statusIcon: statusClr,
                    orderName: item?.category === "vaccine" 
                      ? (item?.lab_order?.vaccine_name || "-") 
                      : (item?.lab_order?.lab_order_name || "-"),
                    TimePlaced: item?.lab_order?.created_at || "-",
                    EndTime: item?.lab_order?.end_time || "-",
                    orderStatus: status,
                    action: 'ActivityChart',
                    field_id:item.field_id,
                    category:item.category
                };
            }
            )
            setTableData(tableData)
        }
    }catch(err){

    }
  }

  const statusIcons = {
    green: (
      <>
        <path d="M16.3009 6.20337L10.0042 12.5L6.85669 9.3517" stroke="#0DAC59" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17.5 10C17.5 14.1425 14.1425 17.5 10 17.5C5.8575 17.5 2.5 14.1425 2.5 10C2.5 5.8575 5.8575 2.5 10 2.5C11.2108 2.5 12.3508 2.79417 13.3633 3.30333" stroke="#0DAC59" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </>
    ),
    yellow: (
      <>
        <circle cx="10.0002" cy="10.0002" r="7.50312" stroke="#E4B200" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.0708 8.07068C8.26832 7.21938 9.04368 6.62913 9.91684 6.66537C10.8941 6.61124 11.7318 7.35591 11.7926 8.33273C11.7926 9.58651 10.0002 10.0001 10.0002 10.8338" stroke="#E4B200" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.1043 13.1263C10.1043 13.1839 10.0576 13.2305 10.0001 13.2305C9.94254 13.2305 9.89588 13.1839 9.89588 13.1263C9.89588 13.0688 9.94254 13.0221 10.0001 13.0221" stroke="#E4B200" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.0002 13.0222C10.0578 13.0222 10.1044 13.0689 10.1044 13.1264" stroke="#E4B200" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </>
    ),
    blue: (
      <>
        <circle cx="10.0002" cy="10.0002" r="7.50312" stroke="#174ADD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.0708 8.07068C8.26832 7.21938 9.04368 6.62913 9.91684 6.66537C10.8941 6.61124 11.7318 7.35591 11.7926 8.33273C11.7926 9.58651 10.0002 10.0001 10.0002 10.8338" stroke="#174ADD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.1043 13.1263C10.1043 13.1839 10.0576 13.2305 10.0001 13.2305C9.94254 13.2305 9.89588 13.1839 9.89588 13.1263C9.89588 13.0688 9.94254 13.0221 10.0001 13.0221" stroke="#174ADD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.0002 13.0222C10.0578 13.0222 10.1044 13.0689 10.1044 13.1264" stroke="#174ADD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </>
    ),
  };
  const statusDetector = (status) => {
        return <div class={`badge ${status.toLowerCase() == 'passed' ? 'sh_badgeSuccess' : status.toLowerCase() == 'not started' ? 'sh_badgePending' : status.toLowerCase() == 'failed' ? "sh_badgeDanger" : 'sh_badgeWarning'} `}>
            <span class="pr-1">
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="4" cy="4" rx="4" ry="4" fill={`${status.toLowerCase() == 'passed' ? '#0F8647' : status.toLowerCase() == 'not started' ? '#1D2433CC' : status.toLowerCase() == 'failed' ? "#E02D3C" : '#CA8B14'}`}></ellipse>
                </svg>

            </span>
            {capitalizeName(status.toLowerCase())}
        </div>
    }
    const orderLabToogleHandler=(id,field_id,type)=>{      
        if (type?.toLowerCase() == 'lab' || type == 'Lab - Point of Care') {
              ToggleOrders(field_id)
        } else if (type?.toLowerCase() == 'vaccine') {
            addVaccineToogleHandler(field_id)
        }
        setActiveEditId(id)
    }

  return (
    <div className="col-8">
      <div className="card sh_basecard cardhtmd">
        <div className="card-header p-2 sh_basecardHeader">
          <div className="d-flex w-100 justify-content-between align-items-center">
            Order and Results
            <div className="d-flex flex-column">
              <div className="progress w-100 sh_emrprogressbar">
                <div
                  className="progress-bar bg-success"
                  role="progressbar"
                  style={{ width: '30%' }}
                  aria-valuenow="30"
                  aria-valuemin="0"
                  aria-valuemax="100"
                />
              </div>
              <div className="d-flex align-items-center">
                <span className="p2-strong pr-1">Pending Results</span>
                <p className="p3-light mb-0">07/03/2025, 10:27 AM</p>
              </div>
            </div>
          </div>
        </div>

        <div className="card-body py-2 px-0 sh_basecardBody">
          <table className="table sh_tablenew">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" id="header-check" />
                </th>
                <th>Status</th>
                <th>Order Placed</th>
                <th>Time Placed</th>
                <th>Total time</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {TableData.map((row, index) => (
                <tr key={index}>
                  <td>
                    <input type="checkbox" id={`check-${index}`} />
                  </td>
                  <td>
                    <span>
                         <Icons fontSize="15px" type={row.statusIcon} />
                      {/* <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {statusIcons[row.statusIcon]}
                      </svg> */}
                    </span>
                  </td>
                  <td>
                    <a href="#">{row.orderName}</a>
                  </td>
                  <td>{row.TimePlaced}</td>
                  <td>{row.EndTime}</td>
                  <td className="forTable_textEllipsis"> {statusDetector(row.orderStatus)}</td>
                  <td><Buttons iconType={row.action} acl={'any'}  clickHandler={()=>orderLabToogleHandler(row.rowId,row.field_id,row.category)}/></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
export default (OrdersAndResultsSection)